import React from 'react'
import MaterialSymbol from '../material-symbol'

const EmojiEvents = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="emoji_events" {...props} />
))

EmojiEvents.displayName = 'EmojiEvents'

export default EmojiEvents
